import { RESET_ALL as RESET_ON_LOGOUT, danger } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';
import { fetchInstagramThumbnailUrl } from 'utils/content/instagram-gql-fallback';

import type { Action, ContentListPostPayload, Dispatch, ThunkAction } from 'types';
import type { WrappedPostLoadingState } from 'modules/lists-content/components/wrapped-post/WrappedPost.type';

applyTranslations(require('./content-list-reducers.i18n.json'));

const { CONTENT_LISTS } = API.END_POINTS;

const CHANGE_STATE = 'wrappedPost/CHANGE_STATE';
const LOADED = 'wrappedPost/LOADED';
const RESET = 'wrappedPost/RESET';

type State = {
  postData: Partial<ContentListPostPayload>,
  loadingState: WrappedPostLoadingState
};

const initialState: State = {
  postData: {},
  loadingState: 'initial'
};

const contentLoaded = (postData: {}): Action => ({
  type: LOADED,

  payload: {
    postData
  }
});

const changeState = (loadingState: WrappedPostLoadingState): Action => ({
  type: CHANGE_STATE,

  payload: {
    loadingState
  }
});

export const resetPost = (): Action => ({
  type: RESET
});

export const fetchPost = (orgId: number, postId: string): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(changeState('loading'));

  try {
    const { data } = await get(CONTENT_LISTS.getPost(orgId, postId), {}, { suppressGlobalNotification: true });
    const url = await fetchInstagramThumbnailUrl(data.url);

    dispatch(contentLoaded({
      ...data,
      assetUrl: url
    }));
    dispatch(changeState('loaded'));
  } catch (e) {
    logError(e);
    const code = e.response?.status;
    if (code === 404) {
      dispatch(danger(__t('content_list_reducers.post_not_found_error')));
    } else {
      dispatch(danger(__t('content_list_reducers.post_loading_error')));
    }
    dispatch(changeState('error'));
  }
};

export default createReducer<State, any>('wrappedPost', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [CHANGE_STATE]: (state, { loadingState }) => ({
    ...state,
    loadingState
  }),
  [LOADED]: (state, { postData }) => ({
    ...state,
    postData
  })
});
